import Config from '../../../Config';

const brandNameHe = () => window.Config?.brand_Name_HE;
const trackerItemText = {
  itemList: {
    followUpRefund: {
      underReview: {
        title: {
          value: 'בקשת הזיכוי שלך בבדיקה',
          MarketingId: 'FeedStatus_2001',
        },
        subTitle: { value: 'נעדכן אותך לגבי התשובה עד ה-{0}', MarketingId: 'FeedStatus_2001' },
      },
      underReviewWithSLA: {
        title: { value: 'בקשת הזיכוי שלך עדיין בבדיקה', MarketingId: 'FeedStatus_2002' },
        subTitle: { value: 'נעדכן אותך עד ה-{0}', MarketingId: 'FeedStatus_2002' },
      },
      confirmed: {
        title: { value: 'אישרנו את בקשת הזיכוי שלך', MarketingId: 'FeedStatus_2003' },
      },
      notConfirmed: {
        title: { value: 'בקשת הזיכוי שלך לא אושרה', MarketingId: 'FeedStatus_2004' },
      },
      notConfirmedYet: {
        title: { value: 'בקשת הזיכוי שלך בבדיקה', MarketingId: 'FeedStatus_2005' },
        subTitle: { value: 'תהיה לנו תשובה\n במועד סגירת החשבונית הבאה', MarketingId: 'FeedStatus_2005' },
      },
      notConfirmedYetAfterInvoice: {
        title: { value: 'סיימנו את הטיפול בבקשת הזיכוי', MarketingId: 'FeedStatus_2006' },
        subTitle: { value: 'התשובה תופיע בחשבונית הבאה', MarketingId: 'FeedStatus_2006' },
      },
    },
    refund: {
      benefitApproved: {
        title: { value: 'סיימנו את הטיפול בבקשת הזיכוי', MarketingId: '' },
        subTitle: '',
      },
      approved: {
        title: { value: 'אישרנו את בקשת הזיכוי שלך', MarketingId: '' },
        subTitle: '',
      },
      underReview: {
        title: { value: 'בקשת הזיכוי שלך בבדיקה', MarketingId: '' },
        subTitle: { value: 'נעדכן אותך לגבי התשובה\n עד ה-{0}', MarketingId: '' },
      },
      notApproved: {
        title: { value: 'בקשת הזיכוי שלך לא אושרה', MarketingId: '' },
        subTitle: '',
      },
      approvedWithReview: {
        title: { value: 'אישרנו את בקשת הזיכוי', MarketingId: '' },
        subTitle: '',
      },
      waitForInvoice: {
        title: { value: 'בקשת הזיכוי בהמתנה', MarketingId: '' },
        subTitle: { value: 'תהיה תשובה במועד סגירת החשבונית הבאה\n ונעדכן אותך עד ה-{0}', MarketingId: '' },
        subTitle: '',
      },
      processEnd: {
        title: { value: 'סיימנו לטפל בבקשת הזיכוי', MarketingId: '' },
        subTitle: '',
      },
    },
    waitingForCall: {
      title: { value: 'קבענו לדבר!', MarketingId: 'FeedStatus_200' },
      subTitle: { value: 'נחזור אליך טלפונית עד ל -{0}', MarketingId: 'FeedStatus_2008' },
    },
    changePricePlan: {
      confirmed: {
        title: { value: 'יש לך חבילה חדשה!', MarketingId: 'FeedStatus_2007' },
        subTitle: { value: 'ב-{0} עדכנו חבילת סלולר\n חדשה למנוי {1}', MarketingId: 'FeedStatus_2007' },
      },
      requestExcepted: {
        title: { value: 'יש לך חבילה חדשה!', MarketingId: 'FeedStatus_2007' },
        subTitle: { value: 'חבילת סלולר למנוי {1}\n תיכנס לתוקף ב-{0}', MarketingId: 'FeedStatus_2007' },
      },
    },
    technicianVisit: {
      title: { value: 'תיאמנו לכם טכנאי {0}', MarketingId: 'Tech_1000' },
      subTitle: { value: 'הטכנאי יגיע אליך בתאריך:  ', MarketingId: '' },
      dateTime: { value: ' {2} בין השעות {0} - {1}', MarketingId: '' },
    },
  },
  title: {
    refund: {
      title: 'בקשת הזיכוי',
      status: {
        confirmed: 'אושרה',
        notConfirmed: 'לא אושרה',
        underReview: 'בבדיקה',
        underReviewWithSLA: 'עדיין בבדיקה',
        notConfirmedYet: 'בהמתנה לסגירת חשבונית',
        NotConfirmedYetAfterInvoice: 'הטיפול הסתיים',
      },
    },

    waitingForCall: {
      title: 'שיחה',
      manager: 'עם מנהל שירות/מומחה טכני',
      status: 'תזכורת',
    },
    changePricePlan: {
      title: 'עדכון תוכנית',
      status: {
        confirmed: 'אושר',
        requestExcepted: 'פנייתך נקלטה',
      },
    },
    personalReminder: {
      title: 'חזרה אישית',
      with: 'עם נציג',
      status: 'תזכורת',
    },
    technicianVisit: {
      title: { value: 'מתואם לכם טכנאי {0}', MarketingId: '' },
      subTitle: { value: 'הטכנאי יגיע אליכם בתאריך: \n {0} - {1} | {2}', MarketingId: '' },
    },
    technicianVisitFiber: {
      subTitle: { value: 'הגעת טכנאי', MarketingId: '' },
      title: { value: 'סופר פייבר', MarketingId: '' },
    },
  },
  body: {
    followUpRefund: {
      underReview: {
        title: { value: 'אנחנו בודקים את הבקשה שלך', MarketingId: '' },
        text: {
          textWithAmount: {
            value: 'בקשת הזיכוי שלך בסך {1} ₪ נמצאת בבדיקה. \n נעדכן אותך עד ה-{0}. \n בינתיים אפשר לעקוב כאן אחר מצב הבקשה.',
            MarketingId: '',
          },
          textNoAmount: { value: 'נעדכן אותך עד ה-{0}. \n בינתיים אפשר לעקוב כאן אחר מצב הבקשה.', MarketingId: '' },
        },
      },
      underReviewWithSLA: {
        title: { value: 'הבקשה שלך עדיין בבדיקה', MarketingId: '' },
        text: {
          textWithAmount: {
            value: 'בקשת הזיכוי שלך בסך {1} ₪ עדיין בבדיקה. \n נעדכן אותך עד ה-{0}. \n בינתיים אפשר לעקוב כאן אחר מצב הבקשה.',
            MarketingId: '',
          },
          textNoAmount: { value: 'נעדכן אותך עד ה-{0}. \n בינתיים אפשר לעקוב כאן אחר מצב הבקשה.', MarketingId: '' },
        },
      },
      notConfirmed: {
        title: { value: 'בקשת הזיכוי לא אושרה', MarketingId: '' },
        text: {
          textWithAmount: { value: 'בקשת הזיכוי מתאריך {0} בסך {1} ₪ לא אושרה.', MarketingId: '' },
          textNoAmount: { value: 'בקשת הזיכוי מתאריך {0} בסך לא אושרה.', MarketingId: '' },
        },
        actions: {
          //deleteMessage: 'מחיקת הודעה',
        },
      },
      confirmed: {
        title: { value: 'אישרנו את בקשת הזיכוי שלך', MarketingId: '' },
        text: {
          textNoAmount: { value: 'הזיכוי יופיע בחשבונית הקרובה שלך.', MarketingId: '' },
          textWithAmount: { value: 'זיכוי בסך {1} יופיע בחשבונית הקרובה שלך.', MarketingId: '' },
        },
        actions: {
          editVisit: 'עדכן',
          addToCalendar: 'תזכורת ליומן',
          //deleteMessage: 'מחיקת הודעה',
        },
        get calendarEventName() {
          return `זיכוי מחברת ${brandNameHe()}`;
        },
      },
      notConfirmedYet: {
        title: { value: 'אנחנו בודקים את בקשת הזיכוי שלך', MarketingId: '' },
        text: {
          textWithAmount: { value: 'תשובה בקשר לבקשת הזיכוי בסך {1} ₪ \n תעודכן במועד סגירת החשבונית הבאה.', MarketingId: '' },
          textNoAmount: { value: 'תהיה לנו תשובה במועד סגירת החשבונית הבאה.', MarketingId: '' },
        },
      },
      notConfirmedYetAfterInvoice: {
        title: { value: 'סיימנו את הטיפול בבקשת הזיכוי שלך', MarketingId: '' },
        text: {
          textWithAmount: { value: 'תשובה בקשר לבקשת הזיכוי בסך {1} ₪ תופיע בחשבונית הבאה.', MarketingId: '' },
          textNoAmount: { value: 'תשובה בקשר לבקשת הזיכוי תופיע בשבונית הבאה.', MarketingId: '' },
        },
        actions: {
          //deleteMessage: 'מחיקת הודעה',
        },
      },
    },
    refund: {
      benefitApproved: {
        title: { value: 'סיימנו את הטיפול בבקשת הזיכוי', MarketingId: '' },
        text: {
          textWithAmount: { value: 'עדכנו לך הטבה שרותית בסך {1} שתופיע בחשבונית של {0}.', MarketingId: '' },
          textNoAmount: { value: 'עדכנו לך הטבה שרותית שתופיע בחשבונית של {0}.', MarketingId: '' },
        },
        actions: {
          //deleteMessage: {value: 'מחיקה', MarketingId: ''},
        },
      },
      approved: {
        title: { value: 'אישרנו את בקשת הזיכוי שלך', MarketingId: '' },
        text: {
          textWithAmount: { value: 'זיכוי בסכום {1} ₪ יופיע בחשבונית של {0}.', MarketingId: '' },
          textNoAmount: { value: 'הזיכוי יופיע בחשבונית של {0}.', MarketingId: '' },
        },
        actions: {
          //deleteMessage: 'מחיקת הודעה',
        },
      },
      underReview: {
        title: { value: 'בקשת הזיכוי שלך בבדיקה', MarketingId: '' },
        //updatedate
        text: {
          textNoAmount: { value: 'נעדכן אותך עד ה-{0} \n בינתיים, אפשר לעקוב כאן אחרי מצב הבקשה.', MarketingId: '' },
          textWithAmount: { value: 'נעדכן אותך עד ה-{0} \n בינתיים, אפשר לעקוב כאן אחרי מצב הבקשה.', MarketingId: '' },
        },
      },
      notApproved: {
        title: { value: 'בקשת הזיכוי לא אושרה', MarketingId: '' },
        //requestdate
        text: {
          textNoAmount: { value: 'בקשת הזיכוי מתאריך {0} לא אושרה.', MarketingId: '' },
          textWithAmount: { value: 'בקשת הזיכוי מתאריך {0} לא אושרה.', MarketingId: '' },
        },
        actions: {
          //deleteMessage: 'מחיקת הודעה',
        },
      },
      approvedWithReview: {
        title: { value: 'אישרנו את הבקשה שלך לזיכוי', MarketingId: '' },
        text: {
          textWithAmount: {
            value:
              'זיכוי בסך {1} ₪ יופיע בחשבונית של {0} \n בינתיים, נבדוק את האפשרות לזכות אותך גם על החודש הנוכחי \n ונחזיר לך תשובה עד ה-{2}.',
            MarketingId: '',
          },
          textNoAmount: {
            value: 'הזיכוי יופיע בחשבונית של {0} \n בינתיים, נבדוק את האפשרות לזכות אותך גם על החודש הנוכחי \n ונחזיר לך תשובה עד ה-{2}.',
            MarketingId: '',
          },
        },
        actions: {
          //deleteMessage: 'מחיקת הודעה',
        },
      },
      waitForInvoice: {
        title: { value: 'בקשת הזיכוי שלך ממתינה לסגירת החשבונית', MarketingId: '' },
        //updatedate
        text: {
          textNoAmount: { value: 'נעדכן אותך עד ה-{0} \n בינתיים, אפשר לעקוב כאן אחר מצב הבקשה.', MarketingEId: '' },
          textWithAmount: { value: 'נעדכן אותך עד ה-{0} \n בינתיים, אפשר לעקוב כאן אחר מצב הבקשה.', MarketingEId: '' },
        },
      },
      processEnd: {
        title: { value: 'סיימנו לטפל בבקשת הזיכוי', MarketingId: '' },
        text: {
          //ininvoicedate                                     //creationdate
          textNoAmount: { value: 'ביטלנו לך את החיוב מהחשבונית של {0}.', MarketingId: '' },
          textWithAmount: { value: 'ביטלנו לך את החיוב מהחשבונית של {0}.', MarketingId: '' },
        },
        actions: {
          //deleteMessage: 'מחיקת הודעה',
        },
      },
    },
    waitingForCall: {
      title: { value: 'קבענו לדבר', MarketingId: '' },
      text: { value: 'בעקבות הבקשה שלך מ-{0}, \n קבענו שנחזור אליך טלפונית עד לתאריך {1}.', MarketingId: '' },
      manager: 'מנהל שירות/מומחה טכני',
      agent: 'נציג שירות',
      techExpert: 'מומחה טכני',
      actions: {
        addToCalendar: { value: 'תזכורת ליומן', MarketingId: '' },
        deleteMessage: { value: 'בעצם, אין צורך שתחזרו אלי', MarketingId: '' },
        //deleteMessage: 'מחיקת הודעה',
      },
    },
    changePricePlan: {
      requestExcepted: {
        title: { value: 'יש לך חבילה חדשה!', MarketingId: '' },
        text: { value: 'בעקבות הבקשה שלך,\n חבילת סלולר חדשה למנוי {0} \n תיכנס לתוקף ב-{1}.', MarketingId: '' },
        actions: {
          //deleteMessage: 'מחיקה',
        },
      },
      confirmed: {
        title: { value: 'יש לך חבילה חדשה!', MarketingId: '' },
        text: { value: 'בעקבות הבקשה שלך, עדכנו את חבילת הסלולר \n של מנוי {0} בתאריך {1}.', MarketingId: '' },
        actions: {
          //deleteMessage: 'מחיקה',
        },
        get calenderEventName() {
          return `עדכון תוכנית סלולר ב${brandNameHe()}`;
        },
      },
    },
    personalReminder: {
      text1: 'בעקבות פנייתך ב-{0} לנציג שרות',
      text2: '{0} יחזור אלייך טלפונית',
      text3: 'עד לתאריך {0}',
      with: 'נציג',
    },
    technicianVisit: {
      title: { value: 'תיאמנו לך טכנאי {0}', MarketingId: 'Tech_1000' },
      text: { value: 'טכנאי {0} יגיע אליך בתאריך:', MarketingId: 'Tech_1002' },
      dateTime: { value: '{0} - {1} | {2} ', MarketingId: 'Tech_1003' },
      addressText: { value: 'לכתובת:', MarketingId: 'Tech_1003' },
      address: { value: '{0}', MarketingId: 'Tech_1003' },
      superFiber: {
        get value() {
          return `אנחנו שמחים שהצטרפת לסופר פייבר,\n האינטרנט הביתי המהיר של ${brandNameHe()}. \n בקרוב הגלישה בבית שלך תגיע עד 1,000 Mbps!`;
        },
        MarketingId: 'Tech_1003',
      },
      specialText: {
        value: 'חשוב שמי שיפגוש את הטכנאי יהיה מעל גיל 18',
        MarketingId: 'Tech_1004',
      },
      actions: {
        calenderEventName: { value: 'ביקור טכנאי {0}', MarketingId: '' },
        addToCalendar: { value: 'להוסיף תזכורת ליומן', MarketingId: 'Tech_1005' },
        chat: { value: 'צ׳אט עם נציג', MarketingId: 'Tech_1006' },
        editVisit: { value: 'לשנות מועד הגעה', MarketingId: 'Tech_1006' },
        deleteMessage: { value: 'לבטל את הגעת הטכנאי', MarketingId: 'Tech_1006' },
      },
      chatDesc: {
        get value() {
          return `פנייה בעקבות צפייה בביקור טכנאי באפליקציה ${brandNameHe()} אישי.`;
        },
        MarketingId: '',
      },
    },
    technicianVisitFiber: {
      title: { value: 'הגעת טכנאי סופר פייבר', MarketingId: 'Tech_1000' },
      desc: {
        get value() {
          return `תודה שהצטרפתם לסופר פייבר,\n
                    האינטרנט הביתי הסופר מהיר של ${brandNameHe()} \n
                    לא תאמינו כמה מהיר האינטרנט שלכם יכול להיות, רגע אחרי שהטכנאי יסיים את ההתקנה. \n
                    בקרוב גם אצלכם יגלשו (מה יגלשו? יטוסו!) במהירות של עד Mbps 1,000! \n
                    מתי זה יקרה?`;
        },
        MarketingId: 'Tech_1002',
      },
      dateTime: { value: '{0} - {1}    |    {2} ', MarketingId: 'Tech_1003' },
      address: { value: 'בכתובת:', MarketingId: 'Tech_1003' },
      specialText: {
        value: 'שים לב, בעת הגעת הטכנאי חשוב שיהיה\nמבוגר בבית.',
        MarketingId: 'Tech_1004',
      },
      actions: {
        calenderEventName: { value: 'ביקור טכנאי {0}', MarketingId: '' },
        addToCalendar: { value: 'תזכורת ליומן', MarketingId: 'Tech_1005' },
        chat: { value: 'צ׳אט עם נציג', MarketingId: 'Tech_1006' },
        editVisit: { value: 'עדכן', MarketingId: 'Tech_1006' },
      },
      chatDesc: {
        get value() {
          return `פנייה בעקבות צפייה בביקור טכנאי באפליקציה ${brandNameHe()} אישי`;
        },
        MarketingId: '',
      },
      desc4: { value: 'לכתובת {0}', MarketingId: '' },
    },
    robohold: {
      title: { value: 'שיחה מתוזמנת', MarketingId: '??' },
      subTitle: { value: 'עם מוקד שירות', MarketingId: '??' },
      text1: {
        value: 'קיימת שיחה מתוזמנת ל-{0}\nבשעה {1}\nלמוקד {2} {3}\nאנחנו נתקשר למספר {4}',
        MarketingId: '??',
      },
      actions: {
        cancel: 'אין צורך בשיחה',
      },
    },
    customerDeliveries: {
      calenderEventName: {
        get value() {
          return `שליחות ${brandNameHe()}`;
        },
      },
      calenderEventLocation: { value: '\nהכתובת לשם נגיע {0}' },
      calenderEventText: {
        get value() {
          return `{0} מתואמת לך שליחות ${brandNameHe()} בתאריך\n {1} אנחנו נפגש בין השעות \n בכתובת {2}\n {3} בכל שינוי ניתן להכנס`;
        },
      },
      actions: {
        addToCalendar: { value: 'להוסיף תזכורת ליומן' },
        editVisit: { value: 'לשנות מועד הגעה' },
      },
    },
  },
  popupMassages: {
    refund: {
      cancelCallAreYouSure: '',
    },
    waitingForCall: {
      cancelCal: 'האם לבטל את השיחה?',
    },
  },
};

export default trackerItemText;
